// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__HOIuF","overlay":"hero_overlay__cbixN","content":"hero_content__TMsK+"};